import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {XwaysHoarder2Model} from "./server/XwaysHoarder2Model";
import {RestoreUtils} from "./utils/RestoreUtils";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {XwaysHoarder2GameAssets} from "./XwaysHoarder2GameAssets";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Idle} from "./gameflow/Idle";
import {BackgroundElements} from "./view/BackgroundElements";
import {ReelsView} from "./reels/ReelsView";
import {NormalBet} from "./gameflow/NormalBet";
import {Result} from "./gameflow/Result";
import {NormalWinPresentation} from "./gameflow/NormalWinPresentation";
import {Speedster} from "./debug/Speedster";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {WinView} from "./view/WinView";
import {ZeroBetIdle} from "./gameflow/ZeroBetIdle";
import {XwaysHoarder2ScreenView} from "./view/XwaysHoarder2ScreenView";
import {ForegroundElements} from "./view/ForegroundElements";
import {FreespinIndicatorView} from "./view/FreespinIndicatorView";
import {FreespinReelAnimHandler} from "./reels/reelhandlers/freespin/FreespinReelAnimHandler";
import {TrashSymView} from "./view/TrashSymView";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {SymbolValues} from "./server/XwaysHoarder2Data";
import {XwaysHoarder2Sound} from "./sound/XwaysHoarder2Sound";
import {BonusIntro} from "./view/BonusIntro";
import {BonusOutro} from "./view/BonusOutro";
import {BonusDoors} from "./view/BonusDoors";
import {WaysCounter} from "./view/WaysCounter";
import {FontWeight,FontStyle} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {ScatterReelAnticipationView} from "./view/ScatterReelAnticipationView";
import {AdditonalOverlay} from "./view/AdditonalOverlay";
import {TransitionPlayer} from "./view/transitions/TransitionPlayer";
import {ScreenDarkOverlayView} from "./view/ScreenDarkOverlayView";
import {PlusFsView} from "./view/PlusFsView";
import {gsap} from "gsap";
import {SpineViewUtils} from "./debug/SpineViewUtils";
import {ScreenInteractiveLayer} from "./view/ScreenInteractiveLayer";


export class XW2GameMode extends GameMode {
    static readonly BINGE_SPINS: string = "BINGE_SPINS";
    static readonly SUPER_FREESPIN: string = "SUPER_FREESPIN";
}
export class XwaysHoarder2 extends SlotGame {

    public static transitionPlayer: TransitionPlayer;
    public static buyFeatureName:string = "";
    public static gameFlowController:GameFlowController;
    public static assetLoader:AssetLoader;
    public static model:XwaysHoarder2Model;
    public static backgroundElements:BackgroundElements;
    public static foregroundElements:ForegroundElements;
    public static reelView:ReelsView;
    public static winView:WinView;
    public static fsReelAnimHandler: FreespinReelAnimHandler;
    public static transitionScreen:XwaysHoarder2ScreenView;
    public static fsIndicators: FreespinIndicatorView;
    public static trashSymView: TrashSymView;
    public static soundPlayer:XwaysHoarder2Sound;
    public static bonusIntro:BonusIntro;
    public static bonusOutro:BonusOutro;
    public static bonusDoors:BonusDoors;
    public static waysCounter:WaysCounter;
    public static anticipationView:ScatterReelAnticipationView;
    public static additionalOverlay: AdditonalOverlay;
    public static darkOverlay: ScreenDarkOverlayView;
    public static plusFsView: PlusFsView;
    public static screenInteractive:ScreenInteractiveLayer;

    constructor() {
        super();
    }

    private _defaultSymbolValues: SymbolValues = {
        "M1": {"3": 13, "4": 15, "5": 19, "6": 38},
        "M2": {"3": 12, "4": 14, "5": 18, "6": 36},
        "L1": {"3": 4, "4": 5, "5": 6, "6": 14},
        "M3": {"3": 11, "4": 12, "5": 17, "6": 34},
        "L2": {"3": 2, "4": 3, "5": 4, "6": 12},
        "M4": {"3": 11, "4": 12, "5": 16, "6": 32},
        "L3": {"3": 2, "4": 3, "5": 4, "6": 10},
        "M5": {"3": 8, "4": 10, "5": 15, "6": 30},
        "L4": {"3": 1, "4": 2, "5": 3, "6": 8},
        "M6": {"3": 8, "4": 10, "5": 14, "6": 28},
        "L5": {"3": 1, "4": 2, "5": 3, "6": 6}
}



    public getSymbolString(key:string, data:{3:number, 4:number, 5:number, 6:number}):string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">6</span>
                    <span class="multiplier" data-multiplier="${data[6] * 0.05}">${data[6] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;

    }

    public getPaytable(): Promise<string> {
        const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());
        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });

        let symbolDataValueData = this._defaultSymbolValues;
        if (XwaysHoarder2.model.initData.symbolValues) {
            symbolDataValueData = XwaysHoarder2.model.initData.symbolValues;
            console.log("Using symbolValues from INIT data");
        } else {
            console.log("Using default symbolValues ");
        }

        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name == "Paytable" && asset.loadedData) {

                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("XwaysHoarder2 could not load Paytable");
        });
    }

    public init():Promise<NolimitPlugin> {
        return super.init().then((value:NolimitPlugin) => {

            // model
            XwaysHoarder2.model = new XwaysHoarder2Model(SlotGame.apiPlugin, true);
            // gameFlow
            XwaysHoarder2.gameFlowController = new GameFlowController(SlotGame.apiPlugin, XwaysHoarder2.model);

            // API EVENTS
            // feature
            XwaysHoarder2.apiPlugin.events.once("featureName", (data:string) => {
                XwaysHoarder2.buyFeatureName = data;
            });
            XwaysHoarder2.apiPlugin.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
                for (let index = 0; index < XwaysHoarder2.model.initData.featureBuyTimesBetValue.length; index++) {
                    if (XwaysHoarder2.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                        XwaysHoarder2.buyFeatureName = betData.featureName;
                        Logger.logDev("Opted Feature : ", XwaysHoarder2.buyFeatureName);
                        break;
                    } else {
                        if (XwaysHoarder2.model.data.mode == GameMode.NORMAL && betData.type == APIBetType.NORMAL_BET){
                            XwaysHoarder2.buyFeatureName = "";
                        }
                    }
                }
            });

            XwaysHoarder2.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
                if(XwaysHoarder2.model.gameData){
                    if (XwaysHoarder2.model.gameData.betWayWins.length > 0) {
                        XwaysHoarder2.reelView.hideReelsNoWinOverlay();
                    }
                }
            });

            //const winPres: PotslotWinPresentation = new PotslotWinPresentation();
            const idleNormal: Idle = new Idle();
            const normalBet: NormalBet = new NormalBet();
            const normalResult: Result = new Result();
            const normalWin: NormalWinPresentation = new NormalWinPresentation();
            const zeroBet: ZeroBetIdle = new ZeroBetIdle();

            XwaysHoarder2.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, idleNormal],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWin]
            ]));

            XwaysHoarder2.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.RESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBet],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWin]
            ]));

            XwaysHoarder2.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBet],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWin]
            ]));

            XwaysHoarder2.gameFlowController.addGameModeFlowStatePresentationMap(XW2GameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBet],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, normalWin]
            ]));

            return value;
        });
    }

    public getReady():Promise<NolimitPlugin> {
        return super.getReady().then((value:NolimitPlugin) => {
            const fontLoader:FontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);
            fontLoader.add(OpenSans.NORMAL_800);

            // @ts-ignore
            fontLoader.add({
                family: "OpenSansCondensedBold",
                weight: FontWeight.NORMAL,
                style: FontStyle.NORMAL,
                url: "/resources/fonts/OpenSans_Condensed-Bold.ttf"
            });

            const imageLoader:ImgLoader = new ImgLoader(NolimitApplication.resourcePath);
            for (let image of XwaysHoarder2GameAssets.singleImages){
                imageLoader.add(image, "resources/images/" + image);
            }

            AssetsConfig.addToAssetsConfig(XwaysHoarder2GameAssets.RESOURCES_GROUPS);
            XwaysHoarder2.assetLoader = new AssetLoader(XwaysHoarder2.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(),imageLoader.load(), XwaysHoarder2.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then((values:any) => {

                XwaysHoarder2.soundPlayer= new XwaysHoarder2Sound();
                this.createViewsAndComponents();

                // ReelView inits
                XwaysHoarder2.reelView.changeReelSets(XwaysHoarder2.model.data.nextMode,XwaysHoarder2.model.data.nextFSLevel);


                XwaysHoarder2.reelView.initReels(undefined, XwaysHoarder2.model.data.reels);
                return value;
            });
        });

        //return super.getReady();
    }
    public getReadyToStart(): Promise<NolimitPlugin> {
        return super.getReadyToStart().then((value:NolimitPlugin) => {
            XwaysHoarder2Sound.switchMusic({name:XwaysHoarder2Sound.MAIN_GAME_MUSIC})
            RestoreUtils.startupGame();

            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {

        return super.start().then((value:NolimitPlugin) => {

            return new Promise((resolve, reject) => {
                XwaysHoarder2.gameFlowController.start();
                if (XwaysHoarder2.apiPlugin.isReplay) {
                    XwaysHoarder2.backgroundElements.playIdleLoop(XW2GameMode.NORMAL);
                    XwaysHoarder2.foregroundElements.playIdleLoop(XW2GameMode.NORMAL);
                }
                resolve(value);
            });
        });
    }

    private createViewsAndComponents() {
        XwaysHoarder2.additionalOverlay = new AdditonalOverlay();
        XwaysHoarder2.transitionPlayer = new TransitionPlayer();
        XwaysHoarder2.backgroundElements = new BackgroundElements();
        XwaysHoarder2.reelView = new ReelsView();
        XwaysHoarder2.winView = new WinView();
        XwaysHoarder2.fsReelAnimHandler = new FreespinReelAnimHandler();
        XwaysHoarder2.bonusIntro = new BonusIntro();
        XwaysHoarder2.bonusOutro = new BonusOutro();
        XwaysHoarder2.transitionScreen = new XwaysHoarder2ScreenView();
        XwaysHoarder2.foregroundElements = new ForegroundElements();
        XwaysHoarder2.fsIndicators = new FreespinIndicatorView();
        XwaysHoarder2.trashSymView = new TrashSymView();
        XwaysHoarder2.bonusDoors = new BonusDoors();
        XwaysHoarder2.waysCounter = new WaysCounter();
        XwaysHoarder2.anticipationView = new ScatterReelAnticipationView();
        XwaysHoarder2.darkOverlay = new ScreenDarkOverlayView();
        XwaysHoarder2.plusFsView = new PlusFsView();
        XwaysHoarder2.screenInteractive = new ScreenInteractiveLayer();

        NolimitApplication.addLayer("Speedster", new Speedster());
        //SpineViewUtils.init(XwaysHoarder2GameAssets.RESOURCES_GROUPS.main,XwaysHoarder2.assetLoader);
        NolimitApplication.addLayerAt(XwaysHoarder2.screenInteractive.name, XwaysHoarder2.screenInteractive, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.transitionScreen.name, XwaysHoarder2.transitionScreen, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.bonusOutro.name, XwaysHoarder2.bonusOutro, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.bonusIntro.name, XwaysHoarder2.bonusIntro, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.winView.name, XwaysHoarder2.winView, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.trashSymView.name, XwaysHoarder2.trashSymView);
        NolimitApplication.addLayerAt(XwaysHoarder2.anticipationView.name, XwaysHoarder2.anticipationView, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.darkOverlay.name, XwaysHoarder2.darkOverlay);
        NolimitApplication.addLayerAt(XwaysHoarder2.plusFsView.name, XwaysHoarder2.plusFsView);
        NolimitApplication.addLayerAt(XwaysHoarder2.fsIndicators.name, XwaysHoarder2.fsIndicators);
        NolimitApplication.addLayerAt(XwaysHoarder2.additionalOverlay.name,XwaysHoarder2.additionalOverlay);
        NolimitApplication.addLayerAt(XwaysHoarder2.waysCounter.name,XwaysHoarder2.waysCounter);
        NolimitApplication.addLayerAt(XwaysHoarder2.foregroundElements.name, XwaysHoarder2.foregroundElements, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.bonusDoors.name, XwaysHoarder2.bonusDoors, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.reelView.name, XwaysHoarder2.reelView, 0);
        NolimitApplication.addLayerAt(XwaysHoarder2.backgroundElements.name, XwaysHoarder2.backgroundElements, 0);
    }

    public static getBuyFeaturePrice():number {
        const betLevel:string = XwaysHoarder2.apiPlugin.freeBets.hasFreeBets() ? XwaysHoarder2.apiPlugin.freeBets.getBet() : XwaysHoarder2.apiPlugin.betLevel.getLevel();
        let bet:number = XwaysHoarder2.model.gameData?.playedBetValue || parseFloat(betLevel);
        let price:number = bet;
        if (XwaysHoarder2.buyFeatureName) {
            for (let index:number = 0; index < XwaysHoarder2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (XwaysHoarder2.model.initData.featureBuyTimesBetValue[index].name === XwaysHoarder2.buyFeatureName) {
                    price = XwaysHoarder2.decimalMultiply(bet, XwaysHoarder2.model.initData.featureBuyTimesBetValue[index].price)
                    break;
                }
            }
        }

        return price;
    }

    private static decimalMultiply(a:number, b:number):number {
        return (a*10) * (b*10) / 100;
    }

    private static getAccumulatedRoundWin():number {
        return (XwaysHoarder2.model.gameData?.accumulatedRoundWin || XwaysHoarder2.model.initData.accumulatedRoundWin);
    }

    public static isWinBelowStake():boolean {
        return XwaysHoarder2.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (this.getAccumulatedRoundWin() <= this.getBuyFeaturePrice());
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                ["L2", "L4", "M6"],
                ["L5", "M5", "M5"],
                ["L1", "L4", "M1"],
                ["L1", "L4", "M4"],
                ["L4", "L4", "L2"],
                ["L4", "L2", "L3"]
            ],
            "evaluatedArea": [
                ["L2", "L4", "M6"],
                ["L5", "M5", "M5"],
                ["L1", "L4", "M1"],
                ["L1", "L4", "M4"],
                ["L4", "L4", "L2"],
                ["L4", "L2", "L3"]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "wasFeatureBuy": false,
            "boostedBet": false,
            "brokeTheBank": false,
            "freespinsTriggeredThisSpin": false,
            "freespinsPlayed": 0,
            "freespinsLeft": 0,
            "serverTestInfo": {},
            "reelsAfterCollapse": [
                ["X", "X", "X"],
                ["X", "X", "X"],
                ["X", "X", "X"],
                ["X", "X", "X"],
                ["X", "X", "X"],
                ["X", "X", "X"]
            ],
            "addedNumberOfFreeSpinInThisSpin": 0,
            "symbolSizes": [
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1]
            ],
            "reelsAtStart": [
                [-1, -1, -1],
                [-1, -1, -1],
                [-1, -1, -1],
                [-1, -1, -1],
                [-1, -1, -1],
                [-1, -1, -1]
            ],
            "symbolSizesAtStart": [
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1],
                [1, 1, 1]
            ],
            "nextRespinIsTheLastReSpin": false,
            "reSpinTriggeredByAnotherLoot": false,
            "currentFSLevel": 0,
            "nextFSLevel": 0,
            "featureMap": {
                "XS": [[1, 1, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1]],
                "XW": [[1, 1, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1], [1, 1, 1]]
            },
            "currentTopBarProgression": [0, 0, 0, 0, 0, 0],
            "nextTopBarProgression": [0, 0, 0, 0, 0, 0],
            "thisRespinIsTheLastReSpinReSpin": false,
            "numRespinPlayed": 0,
            "totalWays": 729
        }

    }

    public static screenShake(dur: number, wiggles: number = 40, isVertical: boolean, movepos?: number): gsap.core.Timeline {
        const shakeTl: gsap.core.Timeline = gsap.timeline();
        shakeTl.add(XwaysHoarder2.backgroundElements.screenShake(dur, wiggles, isVertical, movepos));
        shakeTl.add(XwaysHoarder2.foregroundElements.screenShake(dur, wiggles, isVertical, movepos), "<");
        shakeTl.add(XwaysHoarder2.reelView.screenShake(dur, wiggles, isVertical, movepos), "<");

        return shakeTl;
    }
}